import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getCurrentDateTime, request, BASE_URL } from '../../../../../utils';
import { useEffect, useState } from 'react';
import { BALANCE_REGISTER_REPORT_TYPE, REPORT_TYPE } from '../../../../../constants/dropdown';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { toast } from 'react-toastify';


const initialSchemeAllotmentDataObj = {
  data: [],
  loading: false
};

export const SampleCollectionReport = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [openPrint, setOpenPrint] = useState(false);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('HELLLLLLO USERSSSS', user);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const response = await axios.get(`${BASE_URL}/print/hospital/laboratory/sample-collection-report?refId=${JSON.stringify({ report: watch('report'), from_date: watch('from_date'), to_date: watch('to_date') })}`)
     console.log("API url data", response);
     if (response.data.success) {
     const filteredData = response?.data?.data || [];
      if (filteredData.length > 0) {
        console.log("Conditional Data", filteredData);

        const fileName = `Samople_Collection_Report_${JSON.stringify(watch('from_date'))}_to_${JSON.stringify(watch('to_date'))}`;
        
        const formattedData = filteredData.map((item, index) => ({
          "Sr. No.": index + 1,
          'Collection Date': formatDate(item?.dateTime),
          'Bill No.': item?.bill_no,
          'Patient Name': item?.patientName,
          'Uhid No.': item?.uhid,
          'Adm No.': item?.ipd_no,
          'Services': item?.serviceItems?.map(service => service?.test_name).join(", "), // Joining service names,
          'Bill Amount': item?.serviceItems?.map(service => service?.amount).join(", "), // Joining service names,
          
        }));
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      } else {
        toast(`No Data Found For These Filter`, { variant: 'error' });
      }
    } else {
      toast(`Something Went Wrong`, { variant: 'error' });
    }
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Sample Collection Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('to_date')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ report: watch('report'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    ) } >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('to_date')}
                  onClick={handleExcelReport} >
                  Download Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={9} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
